import { render, staticRenderFns } from "./NotificationListGridHeader.vue?vue&type=template&id=6540c775"
import script from "./NotificationListGridHeader.vue?vue&type=script&lang=js"
export * from "./NotificationListGridHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports